import LocalStorageCache from '@leyan/lyjs/dist/es/cache/LocalStorageCache'

import {TOKEN_CACHE_KEY} from 'services/constants'

const tokenCache = new LocalStorageCache(TOKEN_CACHE_KEY)

export default tokenCache
